import { addDays, differenceInDays, format, formatDuration } from 'date-fns';
import { useMemo } from 'react';

import { Tooltip } from '@air/primitive-tooltip';
import { MONTH_DAY_TIME_FORMAT, parseAirDateToISO } from '@air/utilities';
import { reportErrorToBugsnag } from '@air/utils-error';

import { getTableColumnWidth } from '../utils/getTableColumnWidth';
import { RecentlyDeletedTableCell } from './RecentlyDeletedTableCell';

type Props = { recoveryWindow: number; dateDeleted: string };

export const RecentlyDeletedTableCellDaysToRecover = ({ recoveryWindow, dateDeleted }: Props) => {
  const recoverExpiryDate = useMemo(() => {
    if (!dateDeleted || !recoveryWindow) {
      return null;
    }
    try {
      return addDays(parseAirDateToISO(dateDeleted), recoveryWindow);
    } catch (error) {
      reportErrorToBugsnag({
        error,
        context: `Failed to calculate recoverExpiryDate for deleted item`,
        metadata: { dateDeleted: dateDeleted, recoveryWindow: recoveryWindow },
      });
      return null;
    }
  }, [dateDeleted, recoveryWindow]);

  const daysToRecover = recoverExpiryDate
    ? formatDuration(
        {
          days: differenceInDays(recoverExpiryDate, new Date()),
        },
        {
          format: ['days'],
        },
      )
    : 'Unknown';

  return (
    <RecentlyDeletedTableCell width={getTableColumnWidth('daysToRecover')}>
      <Tooltip
        label={recoverExpiryDate ? format(recoverExpiryDate, MONTH_DAY_TIME_FORMAT) : 'Unknown'}
        side="top"
        sideOffset={4}
        align="start"
      >
        <span>{daysToRecover}</span>
      </Tooltip>
    </RecentlyDeletedTableCell>
  );
};
